import { ITeamLeadPodTypeJson } from '@scale/shared/types/expertManagement';
import { GLOBAL_ROLES } from 'react-scale/components/ExpertManagement/constants';
import { useIsCurrentUserAuthorized } from 'react-scale/components/ExpertManagement/hooks/useIsCurrentUserAuthorized';
import {
  permissionsSelector,
  useClientStore,
} from 'react-scale/components/ExpertManagement/stores/client.store';
import {
  podTypeOptionsSelector,
  useStatContextStore,
} from 'react-scale/components/ExpertManagement/stores/statContext.store';
import { shallow } from 'zustand/shallow';

export const useFilteredPodTypeOptions = () => {
  const podTypeOptions = useStatContextStore(podTypeOptionsSelector, shallow);
  const permissions = useClientStore(permissionsSelector, shallow);
  const permittedPodIds = ((permissions?.permissionedPodTypes ?? []) as ITeamLeadPodTypeJson[]).map(
    p => p._id,
  );

  const hasGlobalAccess = useIsCurrentUserAuthorized(GLOBAL_ROLES);

  const filteredPodTypes = hasGlobalAccess
    ? podTypeOptions
    : podTypeOptions.filter(p => permittedPodIds.includes(p.id));

  return filteredPodTypes;
};
